// CF7 activation form thank you redirect
document.addEventListener('wpcf7mailsent', function (event) {
    if (event.detail.contactFormId == '48447') {
        location = '/bedankt-activatie';
    }
}, false);
